import { AppBar as MuiAppBar, Box, styled } from '@mui/material';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'isOnline',
})<{ isOnline: boolean }>(({ theme, isOnline }) => ({
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.grey[400],
  position: 'fixed',
  zIndex: isOnline ? theme.zIndex.drawer + 1 : 0,
}));

const LeftSide = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down(924)]: {
    flexGrow: 1,
  },
  [theme.breakpoints.up(924)]: {
    flexGrow: 0,
  },
  gap: 24,
}));

const RightSide = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
});

export { LeftSide, RightSide, AppBar };
